module.exports = __webpack_public_path__ + "cce8b7ce5951514465076cec393315b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_091118_0090_V_w.jpg
// module id = 360
// module chunks = 0